import { React, useState, useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext"; // Adjust path
import { useSwipeable } from "react-swipeable";
import GamePageLayout from "./GamePageLayout"; // Adjust path
import styles from '../assets/css/CopyPaste.module.css'; // Import NEW CSS Module
import { FaSquareWhatsapp } from "react-icons/fa6"; // WhatsApp Icon
import { MdDelete, MdClose } from "react-icons/md"; // Delete & Close Icons

function CopyPaste() {
  const { id } = useParams(); // Game ID
  const [values, setValues] = useState([]); // Holds pairs [number, amount]
  const [DigitInput, setDigitInput] = useState(""); // Manual digit input
  const [DigitInputWhastapp, setDigitInputWhastapp] = useState(""); // WhatsApp paste input
  const [AmountInput, setAmountInput] = useState(""); // Manual amount input
  const [Repetition, setRepetition] = useState(1); // 1 = No Palti, 0 = With Palti
  const [WhatsappDetail, setWhatsappDetail] = useState(false); // Toggle WhatsApp input modal
  const { isAuthenticated, Addbet, Gameinfo } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false); // Loading state for submit
  const navigate = useNavigate();
  const [GameName, setGameName] = useState("Loading..."); // Game Name state

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Fetch Game Info
  useEffect(() => {
    let isMounted = true;
    if (Gameinfo && id) {
        Gameinfo(id, (res) => {
            if (!isMounted) return;
            if (res.status === 0) {
                message(0, res.msg || "Failed to load game info");
                setGameName("Unknown Game");
            } else if (res.data && res.data.length > 0) {
                setGameName(res.data[0].game_name || "Unknown Game");
            } else {
                 setGameName("Unknown Game");
            }
        });
    } else {
        setGameName("Unknown Game");
    }
     return () => { isMounted = false; };
  }, [id, Gameinfo]);

  // Prevent back navigation (optional)
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = (event) => {
        navigate("/dashboard", { replace: true });
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark",
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // Calculate total bet amount
  const calculateSum = () => {
    return values.reduce((sum, row) => {
      const amount = parseFloat(row[1]); // Amount is at index 1
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  // Generate pairs from manual input
  const generateManualArray = (digitInput, amountInput, repetition) => {
    const digitString = String(digitInput).replace(/[^0-9]/g, '');
    const amount = parseFloat(amountInput);

    if (isNaN(amount) || amount <= 0) { return [0, [], "Please enter a valid amount."]; }
    if (digitString.length % 2 !== 0) { return [0, [], "Digits must be entered in pairs."]; }
    if (digitString.length === 0) { return [0, [], "Please enter digits."]; }


    const resultArray = [];
    const addedPairs = new Set(); // To track added numbers and avoid duplicates from palti

    for (let i = 0; i < digitString.length; i += 2) {
      const pair = digitString.substring(i, i + 2);
      const numPair = parseInt(pair, 10);

      // Add the pair itself if not already added
      if (!addedPairs.has(numPair)) {
          resultArray.push([numPair, amount]);
          addedPairs.add(numPair);
      }


      // Add the reversed pair if "With Palti" (Repetition === 0) and digits are different
      if (repetition === 0 && pair[0] !== pair[1]) {
        const reversedPair = pair[1] + pair[0];
        const numReversedPair = parseInt(reversedPair, 10);
         // Add reversed pair only if it hasn't been added yet
         if (!addedPairs.has(numReversedPair)) {
             resultArray.push([numReversedPair, amount]);
             addedPairs.add(numReversedPair);
         }
      }
    }
    // Sort numerically
    resultArray.sort((a, b) => a[0] - b[0]);
    return [1, resultArray, "success"];
  };

  // Parse WhatsApp message
  const parseWhatsappMessage = (msg) => {
    let parsedBets = [];
    let cleanedMsg = msg.trim();
    // Basic cleaning - might need more robust regex
    cleanedMsg = cleanedMsg.replace(/\[.*?\]\s*.*?:/g, '');
    cleanedMsg = cleanedMsg.replace(/<.*?\]\s*.*?:/g, '');
    cleanedMsg = cleanedMsg.replace(/^\s*[\*-]?\s*/gm, '');

    const lines = cleanedMsg.split('\n');

    lines.forEach(line => {
        const match = line.match(/^(\d{1,2})\s*[-=xX*]\s*(\d+)/);
        if (match && match[1] && match[2]) {
            const number = parseInt(match[1], 10);
            const amount = parseInt(match[2], 10);
            if (!isNaN(number) && number >= 0 && number <= 99 && !isNaN(amount) && amount > 0) {
                parsedBets.push([number, amount]);
            }
        }
    });
    // Remove duplicates based on number, keeping the last amount found for a number
    const uniqueBets = Array.from(new Map(parsedBets.map(item => [item[0], item])).values());
    // Sort numerically
    uniqueBets.sort((a, b) => a[0] - b[0]);
    return uniqueBets;
  };


  // Handle Add Bet button (Manual Input)
  const handleManualAddBet = () => {
    const [status, generatedValues, msg] = generateManualArray(DigitInput, AmountInput, Repetition);
    if (status === 0) {
      message(0, msg);
    } else {
       // Append new bets, removing duplicates based on number
       const currentBetsMap = new Map(values.map(item => [item[0], item]));
       generatedValues.forEach(item => currentBetsMap.set(item[0], item)); // Overwrite existing amount for same number
       setValues(Array.from(currentBetsMap.values()).sort((a,b) => a[0] - b[0])); // Update and sort
      // Clear inputs after successful add
      setDigitInput("");
      setAmountInput("");
    }
  };

  // Handle Add from WhatsApp
  const handleWhatsappAdd = () => {
    if (DigitInputWhastapp === "") { message(0, "Please paste the WhatsApp message."); return; }
    const parsedValues = parseWhatsappMessage(DigitInputWhastapp);
    if (parsedValues.length === 0) { message(0, "Could not find valid bets. Format like 'Number x Amount'."); return; }

    // Append/overwrite based on number
    const currentBetsMap = new Map(values.map(item => [item[0], item]));
    parsedValues.forEach(item => currentBetsMap.set(item[0], item));
    setValues(Array.from(currentBetsMap.values()).sort((a,b) => a[0] - b[0])); // Update and sort

    setWhatsappDetail(false);
    setDigitInputWhastapp("");
  };

  // Handle deleting a specific bet pair
  const handleDelete = (indexToDelete) => {
    setValues(currentValues => currentValues.filter((_, index) => index !== indexToDelete));
  };

  // Render table rows
  const renderRows = () => {
    return values.map((element, index) => (
      <tr key={index} className={styles.tableRow}>
        <td className={styles.tableCell}>{String(element[0]).padStart(2, '0')}</td>
        <td className={styles.tableCell}>{element[1]}</td>
        <td className={styles.tableCell}>
          <button onClick={() => handleDelete(index)} className={styles.deleteButton}>
            <MdDelete />
          </button>
        </td>
      </tr>
    ));
  };

  // Handle final bet submission
  const handleBettingSubmit = () => {
    // ** Keep the setTimeout as requested **
    setIsLoading(true);
    setTimeout(() => {
        if (values.length === 0) {
            message(0, "No bets added to submit.");
            setIsLoading(false); // Reset loading state
            return;
        }

        const transformedValues = values.map((value) => ({
            bet_numbers: String(value[0]).padStart(2, '0'),
            bet_money: value[1],
            type: 1, // Assuming CopyPaste generates Jodi (type 1)
        }));

        let grandTotal = calculateSum();

        if (Addbet) {
            Addbet(id, 1, JSON.stringify(transformedValues), grandTotal, (res) => {
                setIsLoading(false); // Reset loading state
                if (res.status === 0) {
                    message(0, res.msg || "Failed to place bet.");
                } else {
                    message(1, res.msg || "Bet placed successfully!");
                    const today = new Date();
                    const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
                    const receiptData = [ GameName, formattedDate, transformedValues, grandTotal, 'Copy Paste' ];
                    setValues([]); setDigitInput(""); setAmountInput(""); setDigitInputWhastapp("");
                    // Navigate slightly faster after success message shows
                    setTimeout(() => {
                        navigate('/receipt', { state: { receiptData } });
                    }, 500);
                }
            });
        } else {
            setIsLoading(false); // Reset loading state
            message(0, "Betting function not available.");
        }
    }, 1000); // Keep the 1-second delay before initiating the bet process
  };


  // Swipe handlers
  const handlers = useSwipeable({
    onSwipedRight: () => navigate(`/crossing/${id}`),
  });

  return (
    <>
      <GamePageLayout handlers={handlers} id={id} GameName={GameName} new_message={null}>
        {/* Game Type Tabs */}
        <div className={styles.gameList}>
          <Link to={`/play/${id}`} className={styles.gameLink}>
          जोडी/हारुफ़
          </Link>
          <Link to={`/crossing/${id}`} className={styles.gameLink}>
          क्रॉसिंग
          </Link>
          <Link to={`/copypaste/${id}`} className={`${styles.gameLink} ${styles.activeGameLink}`}>
          कॉपी पेस्ट
          </Link>
        </div>

        {/* Input Area */}
        <div className={styles.inputArea}>
           <div className={styles.inputGroup}>
               <label htmlFor="digitInput" className={styles.inputLabel}>Enter Digits (In Pairs)</label>
               <input
                   id="digitInput"
                   type="tel"
                   inputMode="numeric"
                   className={styles.formInput}
                   value={DigitInput}
                   onInput={(e) => setDigitInput(e.target.value.replace(/[^0-9]/g, ''))}
                   placeholder="e.g., 123456"
               />
           </div>
           <div className={styles.inputGroup}>
               <label htmlFor="amountInput" className={styles.inputLabel}>Enter Amount (Per Bet)</label>
               <input
                   id="amountInput"
                   type="number"
                   inputMode="decimal"
                   className={styles.formInput}
                   value={AmountInput}
                   onInput={(e) => setAmountInput(e.target.value.replace(/[^0-9]/g, ''))}
                   placeholder="e.g., 10"
               />
           </div>

           {/* Palti Option & WhatsApp Paste */}
           <div className={styles.optionsContainer}>
                <div className={styles.paltiOption}>
                    <input
                        type="checkbox"
                        id="withPalti"
                        className={styles.paltiCheckbox}
                        checked={Repetition === 0} // 0 means With Palti
                        onChange={(e) => setRepetition(e.target.checked ? 0 : 1)}
                    />
                    <label htmlFor="withPalti" className={styles.paltiLabel}>With Palti</label>
                </div>
                <button className={styles.whatsappPasteButton} onClick={() => setWhatsappDetail(true)}>
                    <FaSquareWhatsapp /> Paste WhatsApp
                </button>
           </div>

           {/* Add Bet Button */}
           <div className={styles.buttonContainer}>
               <button onClick={handleManualAddBet} className={styles.addButton}>
                   Add Bet
               </button>
           </div>
        </div>

        {/* WhatsApp Paste Modal */}
        {WhatsappDetail && (
            <div className={styles.whatsappModalOverlay} onClick={() => setWhatsappDetail(false)}> {/* Close on overlay click */}
                <div className={styles.whatsappModal} onClick={(e) => e.stopPropagation()}> {/* Prevent closing when clicking inside modal */}
                    <button className={styles.closeModalButton} onClick={() => setWhatsappDetail(false)}>
                        <MdClose />
                    </button>
                    <h4 className={styles.modalTitle}>Paste WhatsApp Bets</h4>
                    <textarea
                        className={styles.whatsappTextarea}
                        value={DigitInputWhastapp}
                        placeholder="Paste your WhatsApp message here (e.g., 12 x 10, 34 = 20...)"
                        onChange={(e) => setDigitInputWhastapp(e.target.value)}
                    ></textarea>
                    <div className={styles.modalButtonContainer}>
                        <button onClick={handleWhatsappAdd} className={styles.modalAddButton}>
                            Add from WhatsApp
                        </button>
                    </div>
                </div>
            </div>
        )}


        {/* Bet Preview Table */}
        {values.length > 0 && (
          <div className={styles.previewArea}>
            <h3 className={styles.previewTitle}>Preview Bets ({values.length} Bets)</h3>
            <div className={styles.tableContainer}>
                <table className={styles.previewTable}>
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th>Amount</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>{renderRows()}</tbody>
                </table>
            </div>
          </div>
        )}

        {/* Summary and Play Button */}
        {values.length > 0 && (
            <div className={styles.summaryContainer}>
              <span className={styles.totalAmount}>
                Total: ₹{calculateSum()}
              </span>
              <button
                className={styles.playButton}
                onClick={handleBettingSubmit}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'PLAY'}
              </button>
            </div>
        )}
      </GamePageLayout>
    </>
  );
}

export default CopyPaste;
